<template>
  <b-card>
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div>Buildings</div>
      <b-btn variant="primary btn-round btn-sm ml-5" class="d-block" @click="add">
        <span class="ion ion-md-add"></span>&nbsp; create building
      </b-btn>
    </h4>

    <b-table :striped="true" :bordered="true" class="card-table mt-4" :items="buildings" :fields="fields" v-if="buildings.length">
      <!--<template #cell(sort)="data">
        <b-form-input
          type="number"
          :value="data.item.sort"
          @change="updateTempData('sort', $event)"
          v-if="data.item.id === editingId"
          min="1"
          :max="buildings.length"
        />
        <span v-else v-text="data.item.sort"></span>
      </template>-->
      <template #cell(name)="data">
        <b-form-input type="text" :value="data.item.name" @change="updateTempData('name', $event)" v-if="data.item.id === editingId" />
        <span v-else v-text="data.item.name"></span>
      </template>
      <template #cell(timezone)="data">
        <b-form-select
          :value="data.item.timezone"
          :options="timezoneOptions"
          @change="updateTempData('timezone', $event)"
          v-if="data.item.id === editingId"
        />
        <span v-else v-text="getTimezoneLabel(data.item.timezone)"></span>
      </template>
      <template #cell(actions)="data">
        <div v-if="data.item.id === editingId" class="building-edit-buttons">
          <b-btn variant="primary btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Save" @click="save()"
            ><i class="ion ion-md-checkmark"></i></b-btn
          >&nbsp;
          <b-btn variant="default btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Cancel" @click="cancel()"
            ><i class="ion ion-md-arrow-back"></i
          ></b-btn>
        </div>
        <div v-else>
          <b-btn variant="default btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Edit" @click="edit(data.item.id)"
            ><i class="ion ion-md-create"></i></b-btn
          >&nbsp;
          <b-btn variant="default btn-xs icon-btn md-btn-flat" v-b-tooltip.hover title="Delete" @click="destroy(data.item.id)"
            ><i class="ion ion-md-close"></i
          ></b-btn>
        </div>
      </template>
    </b-table>
    <div class="text-right mt-3">
      <b-btn variant="default" @click="close">Close</b-btn>
    </div>
  </b-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import escape from 'lodash/escape'

import { BUILDING_CREATE, BUILDING_DESTROY, BUILDING_UPDATE } from '@/store/modules/building'
import Id, { isLocalId } from '@/utils/Id'

export default {
  name: 'building-list',
  data: () => ({
    editingId: null,
    tempData: null,
    fields: [
      // { key: 'sort', label: 'Order', class: 'building-td-sort' },
      { key: 'name', label: 'Building name', class: 'building-td-name' },
      { key: 'timezone', label: 'Timezone', class: 'building-td-timezone' },
      { key: 'actions', label: ' ', tdClass: 'text-center text-nowrap' }
    ]
  }),
  computed: {
    ...mapState('building', ['buildingsLoaded']),
    ...mapGetters('building', ['buildings', 'getBuilding']),
    ...mapGetters('timezone', ['timezones', 'getTimezoneLabel']),
    editingBuilding() {
      return this.editingId ? this.getBuilding(this.editingId) : null
    },
    timezoneOptions() {
      let groups = []
      let index = {}
      for (let tz of this.timezones) {
        if (!(tz.group in index)) {
          index[tz.group] = { label: tz.group, options: [] }
          groups.push(index[tz.group])
        }
        index[tz.group].options.push({ value: tz.id, text: `${tz.label} (${tz.offsetLabel})` })
      }
      return groups
    }
  },
  methods: {
    ...mapMutations('building', {
      createLocal_: BUILDING_CREATE,
      destroyLocal_: BUILDING_DESTROY,
      updateLocal_: BUILDING_UPDATE
    }),
    ...mapActions('building', ['buildingSave', 'buildingDestroy']),
    updateTempData(key, value) {
      if (!this.tempData) {
        this.tempData = {}
      }
      value = value instanceof Event ? value.target.value : value
      this.tempData[key] = value
    },
    add() {
      let num = this.buildings.length + 1
      let id = Id()
      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      let building = { id: id, name: `New building ${num}`, sort: num, timezone }
      this.createLocal_(building)
      this.updateTempData('name', building.name)
      this.updateTempData('sort', building.sort)
      this.updateTempData('timezone', building.timezone)
      if (!this.editingId) {
        this.editingId = id
      }
    },
    save() {
      if (this.tempData) {
        if (!(this.tempData.name || typeof this.tempData.name === 'undefined')) {
          this.$appToast.error('Building name cannot be empty!')
        } else if (!(this.tempData.timezone || typeof this.tempData.timezone === 'undefined')) {
          this.$appToast.error('Building timezone cannot be empty!')
        } else {
          this.updateLocal_(Object.assign({ id: this.editingId }, this.tempData))
          this.buildingSave(this.editingBuilding).then(() => {
              this.cancel()
            }, (error) => {
              if (error.response && error.response.status === 422) {
                const errorMessages = error.response.data.map((e) => e.message)
                this.$appToast.error(errorMessages.map(escape).join('<br>'))
              } else {
                throw error
              }
            })
        }
      } else {
        this.cancel()
      }
    },
    destroy(id) {
      this.buildingDestroy(this.getBuilding(id))
    },
    edit(id) {
      if (this.editingId) {
        this.$appToast.error('You are editing some other building.<br>Save or close it.')
      } else {
        this.editingId = id
      }
    },
    cancel() {
      if (this.editingId && isLocalId(this.editingId) && this.editingBuilding) {
        this.destroyLocal_(this.editingBuilding)
      }
      this.editingId = null
      this.tempData = null
    },
    close() {
      this.$emit('close')
    }
  },
  created() {
    if (this.buildingsLoaded && this.buildings.length === 0) {
      this.add()
    }
  },
  beforeDestroy() {
    if (this.editingId) {
      this.save()
    }
  }
}
</script>

<style>
.building-td-sort {
  width: 6.5rem;
}

.building-td-name {
  width: 12rem;
}

.building-td-timezone {
  width: 16rem;
}

.building-edit-buttons {
  vertical-align: middle;
  line-height: 36px;
}
</style>
